import { createSlice } from "@reduxjs/toolkit";

const userDataslice = createSlice({
  name: "userData",
  initialState: {
  userData: {},
    loading: false
  },
  reducers: {
   setUserData: (state, action) => {
    console.log(action,"actiondatatssyudhdlkj")
  if (action.payload.userData)
    state.userData = action.payload.userData;
 
},
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const { setUserData, setLoading } = userDataslice.actions;
export default userDataslice.reducer;
